
import en from './EN.json';
import sr from './SR.json';
import fr from './FR.json';

const p = {
    en: en, 
    sr: sr,
    fr: fr,
};

export default p;